import { createSlice } from '@reduxjs/toolkit';
import {
  getPorfolioCompany,
  deletePortfolioComapny,
} from '../thunk/portfolioComapniesThunk';
const initialState = {
  portfolioComapnyDetails: null,
  loading: false,
  updating: false,
  error: null,
};

const portfolioComapnySlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearPortfolioComapnyDetails: (state) => {
      state.portfolioComapnyDetails = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Contact Details
      .addCase(getPorfolioCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPorfolioCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.portfolioComapnyDetails = action.payload.data;
      })
      .addCase(getPorfolioCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Portfolio Company
      .addCase(deletePortfolioComapny.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePortfolioComapny.fulfilled, (state) => {
        state.loading = false;
        state.portfolioComapnyDetails = null; // Clear data on delete success
      })
      .addCase(deletePortfolioComapny.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPortfolioComapnyDetails } = portfolioComapnySlice.actions;
export default portfolioComapnySlice.reducer;
